/**
 * ALERTAS EM JANELA para quem está logado. [Bruno 2026-10-08]
 *
 * "A pessoa correta vai receber um alerta desse chamado, um popup ou algo
 * assim para ser de rápida visualização e já atender." A triagem da ANA encaminha um
 * chamado ou uma conversa do WhatsApp para alguém e o cockpit dessa pessoa
 * mostra um cartão no canto da tela, com "Atender" (abre direto) e "Depois".
 * Pergunta ao servidor a cada 30 s; os dois botões marcam como visto.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const INTERVALO_MS = 30000;
const MAX_NA_TELA = 3;

const COR = { whatsapp: '#1e7f4f', whatsapp_escalado: '#b3261e', folha: '#7a4fb5', chamado: '#2F5CA6' };

export default function AlertasPopup() {
  const navigate = useNavigate();
  const [alertas, setAlertas] = useState([]);
  const vivo = useRef(true);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get('/painel/alertas');
      if (vivo.current) setAlertas(Array.isArray(data?.alertas) ? data.alertas : []);
    } catch (_) { /* alerta é ajuda, não pode quebrar a tela */ }
  }, []);

  useEffect(() => {
    vivo.current = true;
    carregar();
    const t = setInterval(carregar, INTERVALO_MS);
    return () => { vivo.current = false; clearInterval(t); };
  }, [carregar]);

  const fechar = async (a, abrir) => {
    setAlertas((l) => l.filter((x) => x.id !== a.id));
    try { await api.post(`/painel/alertas/${a.id}/visto`); } catch (_) { /* volta na próxima leitura */ }
    if (abrir && a.link) {
      navigate(a.link);
      // Se a tela do WhatsApp já estava aberta, ela não remonta: avisa qual
      // conversa abrir.
      const m = String(a.link).match(/[?&]conversa=(\d+)/);
      if (m) setTimeout(() => window.dispatchEvent(new CustomEvent('cockpit:abrir-conversa', { detail: Number(m[1]) })), 0);
    }
  };

  if (!alertas.length) return null;
  const visiveis = alertas.slice(0, MAX_NA_TELA);
  return (
    <div role="region" aria-label="Alertas para você" style={{
      position: 'fixed', right: 18, bottom: 18, zIndex: 2500, width: 360, maxWidth: 'calc(100vw - 36px)',
      display: 'flex', flexDirection: 'column', gap: 10,
    }}>
      {alertas.length > MAX_NA_TELA && (
        <div style={{ alignSelf: 'flex-end', fontSize: 12, fontWeight: 700, background: 'var(--ckd-bg-1a234b, #1A234B)', color: 'var(--ckd-tx-ffffff, #fff)', borderRadius: 999, padding: '3px 10px' }}>
          +{alertas.length - MAX_NA_TELA} alerta(s)
        </div>
      )}
      {visiveis.map((a) => (
        <div key={a.id} role="alert" style={{
          background: 'var(--paper, #fff)', color: 'var(--ink, #15171C)', borderRadius: 12,
          border: '1px solid var(--line, #d9dee8)', borderLeft: `5px solid ${COR[a.tipo] || COR.chamado}`,
          boxShadow: '0 10px 30px rgba(0,0,0,0.18)', padding: '12px 14px',
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: COR[a.tipo] || COR.chamado }}>
            {a.tipo === 'whatsapp' || a.tipo === 'whatsapp_escalado' ? 'WhatsApp' : 'Chamado'} · para você
          </div>
          <div style={{ fontWeight: 700, fontSize: 14, margin: '3px 0 4px' }}>{a.titulo}</div>
          {a.texto && <div style={{ fontSize: 13, lineHeight: 1.4, color: 'var(--ink-3, #555)' }}>{a.texto}</div>}
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => fechar(a, true)}>Atender</button>
            <button type="button" className="btn btn-outline btn-sm" onClick={() => fechar(a, false)}>Depois</button>
          </div>
        </div>
      ))}
    </div>
  );
}
